import { render, staticRenderFns } from "./studentMessage.vue?vue&type=template&id=0a9b8136&scoped=true"
import script from "./studentMessage.vue?vue&type=script&lang=js"
export * from "./studentMessage.vue?vue&type=script&lang=js"
import style0 from "./studentMessage.vue?vue&type=style&index=0&id=0a9b8136&prod&scoped=true&lang=less"
import style1 from "./studentMessage.vue?vue&type=style&index=1&id=0a9b8136&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9b8136",
  null
  
)

export default component.exports